import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { switchMap } from 'rxjs/operators';
import { UserService as UserService2 } from 'app/core/auth/tmp/user2.service';
@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _router: Router,
        private _userService2: UserService2,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param redirectURL
     * @private
     */
    private _check(redirectURL: string, route?: ActivatedRouteSnapshot): Observable<boolean>
    {
        return this._authService.check()
            .pipe(
                switchMap((authenticated) => {
                    if (!authenticated) {
                        this._router.navigate(['sign-in'], {queryParams: {redirectURL}});
                        return of(false);
                    }

                    const userID = this._authService.userID();
                    const rol = '';


                    const user = this._userService2.userDetail();
                    if (!user) {
                        return this._userService2.user(userID, rol).pipe(
                            switchMap(() => this.validateRole(route))
                        );
                    }

                    return this.validateRole(route);
                })
            );
    }

    private validateRole(route?: ActivatedRouteSnapshot): Observable<boolean> {
        const rolesPermitidos: string[] = route?.data?.['rolesPermitidos'];
        const userRol = this._userService2.userDetail()?.rol;

        if (rolesPermitidos?.length > 0) {
            if (!rolesPermitidos.includes(userRol)) {
                // Redirige si no tiene permiso
                if (userRol === 'ROLE_ADMIN_AUXILIAR') {
                    this._router.navigate(['/catalogo/administracion/listado/recetas/todas']);
                } else {
                    this._router.navigate(['/paciente']);
                }
                return of(false);
            }
        }

        return of(true);
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl, route);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl, childRoute);
    }

    /**
     * Can load
     *
     * @param route
     * @param segments
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean
    {
        return this._check('/');
    }
}
